/**
 * ScrollToTop Component
 * 
 * Ensures that when navigating between routes, the page scrolls to the top.
 * This fixes the issue where pages don't start at the top when opened on mobile.
 */

import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  // Use useLayoutEffect for synchronous execution BEFORE paint - eliminates delay
  useLayoutEffect(() => {
    // Scroll to top instantly when route changes - synchronous, no delay
    window.scrollTo(0, 0);
    
    // Also scroll the root element if it's scrollable
    const root = document.getElementById('root');
    if (root) {
      root.scrollTop = 0;
    }
    
    // Scroll any scrollable containers to top - synchronous
    const scrollableContainers = document.querySelectorAll('.dashboard-main, .login-container');
    scrollableContainers.forEach(container => {
      if (container) {
        container.scrollTop = 0;
      }
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;

